<template>
  <f7-block>
    <f7-block-title>{{ $t('adminDashboard.marketplace') }}</f7-block-title>
    <div class="metric-grid">
      <div class="metric-card">
        <f7-icon f7="store" size="20" class="metric-icon color-teal" />
        <span class="metric-lbl">{{ $t('adminDashboard.totalShops') }}</span>
        <span class="metric-val">{{ fmt(data.totalShops) }}</span>
      </div>
      <div class="metric-card">
        <f7-icon f7="store_fill" size="20" class="metric-icon color-green" />
        <span class="metric-lbl">{{ $t('adminDashboard.activeShops') }}</span>
        <span class="metric-val">{{ fmt(data.activeShops) }}</span>
      </div>
      <div class="metric-card">
        <f7-icon f7="tag_fill" size="20" class="metric-icon color-orange" />
        <span class="metric-lbl">{{ $t('adminDashboard.totalListings') }}</span>
        <span class="metric-val">{{ fmt(data.totalListings) }}</span>
      </div>
      <div class="metric-card">
        <f7-icon f7="cart_fill" size="20" class="metric-icon color-purple" />
        <span class="metric-lbl">{{ $t('adminDashboard.totalOrders') }}</span>
        <span class="metric-val">{{ fmt(data.totalOrders) }}</span>
      </div>
      <div class="metric-card">
        <f7-icon f7="chart_bar_square" size="20" class="metric-icon color-pink" />
        <span class="metric-lbl">{{ $t('adminDashboard.marketplaceRevenue') }}</span>
        <span class="metric-val">{{ fmtCfa(data.marketplaceRevenue) }}</span>
      </div>
      <div class="metric-card" v-if="data.marketplaceGrowthRate != null">
        <span class="metric-lbl">{{ $t('adminDashboard.marketplaceGrowthRate') }}</span>
        <span class="metric-val trend-pill" :class="trendClass(data.marketplaceGrowthRate)">
          {{ pct(data.marketplaceGrowthRate) }}
        </span>
      </div>
    </div>
  </f7-block>
</template>
<script setup>
const props = defineProps({ data: { type: Object, required: true } });
function fmt(n) { return n != null ? Math.round(n).toLocaleString('fr-FR') : '-'; }
function pct(v) { return v != null ? v.toFixed(1) + '%' : '-'; }
function fmtCfa(v) { if (v == null) return '-'; const n = parseFloat(v) || 0; return n.toLocaleString('fr-FR', {maximumFractionDigits:0}) + ' FCFA'; }
function trendClass(v) { if (v > 0) return 'trend-up'; if (v < 0) return 'trend-down'; return 'trend-neutral'; }
</script>
<style scoped>
.metric-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px; }
.metric-card { display:flex; flex-direction:column; align-items:center; gap:4px; padding:14px 8px; border-radius:12px; background:var(--f7-list-bg-color,#f5f5f5); }
.metric-icon { margin-bottom:2px; }
.metric-lbl { font-size:11px; color:var(--f7-on-surface-variant,#8e8e93); text-align:center; line-height:1.3; }
.metric-val { font-size:18px; font-weight:700; color:var(--f7-text-color,#333); }
.trend-pill { padding:4px 10px; border-radius:20px; font-size:13px; font-weight:600; }
.trend-up { background:color-mix(in srgb,#4caf50 12%,transparent); color:#4caf50; }
.trend-down { background:color-mix(in srgb,#f44336 12%,transparent); color:#f44336; }
.trend-neutral { background:var(--f7-list-bg-color,#f5f5f5); color:var(--f7-on-surface-variant,#8e8e93); }
</style>